module.exports = __webpack_public_path__ + "static/media/Background@3x.4ec988a9.jpg";